import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/Bookit-dark-logo.svg'
import _imports_1 from '@/assets/lang/HE.png'
import _imports_2 from '@/assets/lang/EN.png'
import _imports_3 from '@/assets/lang/RU.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b161af78")

_pushScopeId("data-v-b161af78")
const _hoisted_1 = { id: "bookit-header" }
const _hoisted_2 = {
  class: "navbar navbar-expand-lg navbar-light pt-lg-4",
  id: "main-navbar"
}
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { class: "logo" }, null, -1)
const _hoisted_6 = {
  src: _imports_0,
  class: "logo-after-expand"
}
const _hoisted_7 = { class: "navbar-nav mb-2 mb-lg-0" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-documents fs-32 nav-icon" }, null, -1)
const _hoisted_9 = { class: "nav-text" }
const _hoisted_10 = {
  key: 0,
  class: "nav-item index-navbar-item"
}
const _hoisted_11 = { class: "nav-link position-relative" }
const _hoisted_12 = {
  key: 0,
  class: "dropdown to-end lg-unset-anchor"
}
const _hoisted_13 = { class: "nav-item-text" }
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "nav-item-text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = { class: "nav-item-text" }
const _hoisted_18 = {
  key: 1,
  class: "nav-item index-navbar-item"
}
const _hoisted_19 = { class: "nav-link position-relative" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-documents fs-32 nav-icon" }, null, -1)
const _hoisted_21 = { class: "nav-text" }
const _hoisted_22 = { class: "dropdown to-end lg-unset-anchor" }
const _hoisted_23 = { class: "nav-item-text" }
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_25 = { class: "nav-item-text" }
const _hoisted_26 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_27 = { class: "nav-item-text" }
const _hoisted_28 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_29 = { class: "nav-item-text" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-catalog fs-32 nav-icon" }, null, -1)
const _hoisted_31 = { class: "nav-text" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-orders fs-32 nav-icon" }, null, -1)
const _hoisted_33 = { class: "nav-text" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-settings fs-32 nav-icon" }, null, -1)
const _hoisted_35 = { class: "nav-text" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-portrait fs-32 nav-icon" }, null, -1)
const _hoisted_37 = { class: "nav-text" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-documents fs-32 nav-icon" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "nav-text"
}
const _hoisted_40 = {
  key: 1,
  class: "nav-text"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-newreciept fs-32 nav-icon" }, null, -1)
const _hoisted_42 = {
  key: 0,
  class: "nav-text"
}
const _hoisted_43 = {
  key: 1,
  class: "nav-text"
}
const _hoisted_44 = {
  key: 3,
  class: "nav-item index-navbar-item"
}
const _hoisted_45 = { class: "nav-link position-relative" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-documents fs-32 nav-icon" }, null, -1)
const _hoisted_47 = { class: "nav-text" }
const _hoisted_48 = { class: "dropdown to-end lg-unset-anchor" }
const _hoisted_49 = { class: "nav-item-text" }
const _hoisted_50 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_51 = { class: "nav-item-text" }
const _hoisted_52 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_53 = { class: "nav-item-text" }
const _hoisted_54 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_55 = { class: "nav-item-text" }
const _hoisted_56 = { class: "nav-item profile-menu" }
const _hoisted_57 = {
  class: "nav-link align-items-center",
  href: "#",
  style: {"position":"relative"}
}
const _hoisted_58 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  class: "nav-icon"
}, [
  /*#__PURE__*/_createVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("g", { transform: "translate(-29 -112) translate(29 112)" }, [
        /*#__PURE__*/_createVNode("circle", {
          cx: "14",
          cy: "14",
          r: "14",
          fill: "#FFF"
        }),
        /*#__PURE__*/_createVNode("path", {
          fill: "#475472",
          d: "M14 16.625c3.864 0 7.334 1.44 9.202 3.71C20.957 22.889 17.667 24.5 14 24.5h.154-.307c-3.605-.045-6.835-1.647-9.05-4.164 1.87-2.272 5.34-3.71 9.203-3.71zm0-12.25c2.416 0 4.375 2.35 4.375 5.25s-1.96 5.25-4.375 5.25c-2.416 0-4.375-2.35-4.375-5.25s1.96-5.25 4.375-5.25z"
        })
      ])
    ])
  ])
], -1)
const _hoisted_59 = { class: "about-user" }
const _hoisted_60 = { class: "dropdown p-3 to-end lg-unset-anchor" }
const _hoisted_61 = {
  class: "item-account-dropdown",
  href: "#"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-portrait fs-20" }, null, -1)
const _hoisted_63 = { class: "d-lg-flex pt-2 desktop-language-select" }
const _hoisted_64 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-log-out fs-20" }, null, -1)
const _hoisted_66 = { class: "nav-item mobile-language-select" }
const _hoisted_67 = {
  class: "d-flex position-fixed pt-2",
  style: {"bottom":"5%"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpandMenu = false)),
      class: "w-25 blur-block"
    }, null, 512), [
      [_vShow, _ctx.isExpandMenu]
    ]),
    _createVNode("nav", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isExpandMenu = !_ctx.isExpandMenu)),
          class: "navbar-toggler",
          type: "button"
        }, [
          _hoisted_4
        ]),
        _createVNode(_component_router_link, {
          to: "/",
          class: "logo-image",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isExpandMenu = false))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode("div", {
          class: [{ collapse: !_ctx.isExpandMenu }, "navbar-collapse"]
        }, [
          _createVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isExpandMenu = false))
          }, [
            _withDirectives(_createVNode("img", _hoisted_6, null, 512), [
              [_vShow, _ctx.isExpandMenu]
            ])
          ]),
          _createVNode("ul", _hoisted_7, [
            _createVNode("li", {
              class: "nav-item",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isExpandMenu.value = false))
            }, [
              _createVNode(_component_router_link, {
                to: "/providers",
                class: "nav-link"
              }, {
                default: _withId(() => [
                  _hoisted_8,
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('navbar.providers')), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock("li", _hoisted_10, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode("i", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isExpandIndexMenu = !_ctx.isExpandIndexMenu)),
                      class: "icon-f icon-documents fs-32 nav-icon"
                    }),
                    _createVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isExpandIndexMenu = !_ctx.isExpandIndexMenu)),
                      class: "nav-text"
                    }, _toDisplayString(_ctx.$t('navbar.index')), 1),
                    (_ctx.isExpandIndexMenu)
                      ? (_openBlock(), _createBlock("ul", _hoisted_12, [
                          _createVNode("li", null, [
                            _createVNode(_component_router_link, {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isExpandMenu = _ctx.isExpandIndexMenu = false)),
                              to: "/index-management",
                              class: "nav-link p-2"
                            }, {
                              default: _withId(() => [
                                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('navbar.promoManagement')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_14,
                          _createVNode("li", null, [
                            _createVNode(_component_router_link, {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isExpandMenu = _ctx.isExpandIndexMenu = false)),
                              to: "/agencies",
                              class: "nav-link p-2"
                            }, {
                              default: _withId(() => [
                                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('navbar.indexAgencies')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_16,
                          _createVNode("li", null, [
                            _createVNode(_component_router_link, {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isExpandMenu = _ctx.isExpandIndexMenu = false)),
                              to: "/index-statistics",
                              class: "nav-link p-2"
                            }, {
                              default: _withId(() => [
                                _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('navbar.index-statistics')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock("li", _hoisted_18, [
                  _createVNode("span", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('navbar.index')), 1),
                    _createVNode("ul", _hoisted_22, [
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/promo-management",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('navbar.promoManagement')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_24,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/agencies",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('navbar.indexAgencies')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_26,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/index-statistics",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('navbar.index-statistics')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_28,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/index-chat-quotes",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('navbar.chatQuotes')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])),
            _createVNode("li", {
              class: "nav-item",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isExpandMenu = false))
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'catalog' },
                class: "nav-link"
              }, {
                default: _withId(() => [
                  _hoisted_30,
                  _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('navbar.products')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode("li", {
              class: "nav-item",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.reloadCurrentPage('orders'), (_ctx.isExpandMenu.value = false)))
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'orders', params: { newSearch: '1' } },
                class: "nav-link"
              }, {
                default: _withId(() => [
                  _hoisted_32,
                  _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('orders.orders')), 1)
                ]),
                _: 1
              })
            ]),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                  _createVNode("li", {
                    class: "nav-item",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isExpandMenu = false))
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/settings",
                      class: "nav-link"
                    }, {
                      default: _withId(() => [
                        _hoisted_34,
                        _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('navbar.settings')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("li", {
                    class: "nav-item",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.isExpandMenu = false;})
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/registration-awaiting",
                      class: "nav-link"
                    }, {
                      default: _withId(() => [
                        _hoisted_36,
                        _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('navbar.registration-awaiting')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("li", {
                    class: "nav-item",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isExpandMenu = false))
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/documents",
                      class: "nav-link"
                    }, {
                      default: _withId(() => [
                        _hoisted_38,
                        (_ctx.isExpandMenu)
                          ? (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('product.documents')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('navbar.docs')), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("li", {
                    class: "nav-item",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isExpandMenu = false))
                  }, [
                    _createVNode(_component_router_link, {
                      to: "/coupon-logs",
                      class: "nav-link"
                    }, {
                      default: _withId(() => [
                        _hoisted_41,
                        (_ctx.isExpandMenu)
                          ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('navbar.coupon-logs')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('navbar.docs')), 1))
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : (_openBlock(), _createBlock("li", _hoisted_44, [
                  _createVNode("span", _hoisted_45, [
                    _hoisted_46,
                    _createVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('navbar.more')), 1),
                    _createVNode("ul", _hoisted_48, [
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/settings",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('navbar.settings')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_50,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/registration-awaiting",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('navbar.registration-awaiting')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_52,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/documents",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('navbar.docs')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_54,
                      _createVNode("li", null, [
                        _createVNode(_component_router_link, {
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isExpandMenu = false)),
                          to: "/coupon-logs",
                          class: "nav-link p-2"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('navbar.coupon-logs')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])),
            _createVNode("li", _hoisted_56, [
              _createVNode("a", _hoisted_57, [
                _hoisted_58,
                _createVNode("div", _hoisted_59, _toDisplayString(_ctx.generalStore.state.user?.fullName), 1)
              ]),
              _createVNode("ul", _hoisted_60, [
                _createVNode("li", null, [
                  _createVNode("a", _hoisted_61, [
                    _hoisted_62,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('navbar.myProfile')), 1)
                  ]),
                  _createVNode("div", _hoisted_63, [
                    _createVNode("div", {
                      class: ["my-auto", { active: _ctx.locale == 'he-IL' }]
                    }, [
                      _createVNode("img", {
                        class: "language-image",
                        src: _imports_1,
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.changeLang('he-IL')))
                      })
                    ], 2),
                    _createVNode("div", {
                      class: ["my-auto", { active: _ctx.locale == 'en-US' }]
                    }, [
                      _createVNode("img", {
                        class: "language-image",
                        src: _imports_2,
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.changeLang('en-US')))
                      })
                    ], 2),
                    _createVNode("div", {
                      class: ["my-auto", { active: _ctx.locale == 'ru-RU' }]
                    }, [
                      _createVNode("img", {
                        class: "language-image",
                        src: _imports_3,
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.changeLang('ru-RU')))
                      })
                    ], 2)
                  ])
                ]),
                _hoisted_64,
                _createVNode("li", null, [
                  _createVNode("span", {
                    class: "item-account-dropdown",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.logout()))
                  }, [
                    _hoisted_65,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('navbar.signOut')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("li", _hoisted_66, [
              _createVNode("div", _hoisted_67, [
                _createVNode("div", {
                  class: ["m-end-3 my-auto", { active: _ctx.locale == 'he-IL' }]
                }, [
                  _createVNode("img", {
                    class: "language-image",
                    src: _imports_1,
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.changeLang('he-IL')))
                  })
                ], 2),
                _createVNode("div", {
                  class: ["m-end-3 my-auto", { active: _ctx.locale == 'en-US' }]
                }, [
                  _createVNode("img", {
                    class: "language-image",
                    src: _imports_2,
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.changeLang('en-US')))
                  })
                ], 2),
                _createVNode("div", {
                  class: ["m-end-3 my-auto", { active: _ctx.locale == 'ru-RU' }]
                }, [
                  _createVNode("img", {
                    class: "language-image",
                    src: _imports_3,
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.changeLang('ru-RU')))
                  })
                ], 2)
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ]))
})